import "../chunk-N3ETBM74.js";
const badgeHref = (locale, pageType) => {
  const url = myProfileUrls.find((url2) => url2.locales.includes(locale));
  return url ? `/${locale}/${url.ferryAccount}/${url[pageType]}${pageType === "bookings" ? "?show=5" : ""}` : "";
};
const myProfileUrls = [
  {
    bookings: "bookings",
    consent: "consent-privacy",
    ferryAccount: "passenger-ferries/account",
    locales: [
      "en",
      "en-gb",
      "bg-bg",
      "zh-cn",
      "cs-cz",
      "fi-fi",
      "it-it",
      "ja-jp",
      "ko-kr",
      "pt-br",
      "ro-ro",
      "ru-ru",
      "sk-sk",
      "tr-tr"
    ],
    profile: "my-profile"
  },
  {
    bookings: "reservas",
    consent: "consentimiento-privacidad",
    ferryAccount: "ferris-de-pasajeros/cuenta",
    locales: ["es-es"],
    profile: "mi-perfil"
  },
  {
    bookings: "bookinger",
    consent: "samtykke-fortrolighed",
    ferryAccount: "passagerfaerger/bruger",
    locales: ["da-dk"],
    profile: "min-profil"
  },
  {
    bookings: "boekingen",
    consent: "toestemming-privacy",
    ferryAccount: "overtochten-passagiers/account",
    locales: ["nl-be", "nl-nl"],
    profile: "mijn-profiel"
  },
  {
    bookings: "broneeringuid",
    consent: "nousolek-privaatsus",
    ferryAccount: "reisilaevad/konto",
    locales: ["et-ee"],
    profile: "minu-profiil"
  },
  {
    bookings: "mes-reservations",
    consent: "consentement-confidentialite",
    ferryAccount: "ferries-passagers/compte",
    locales: ["fr-be", "fr-fr", "fr-ma"],
    profile: "mon-profil"
  },
  {
    bookings: "buchungen",
    consent: "datenschutz-einverstandnis",
    ferryAccount: "passagierfaehren/account",
    locales: ["de-de"],
    profile: "mein-profil"
  },
  {
    bookings: "rezervacijas",
    consent: "piekrisana-privatums",
    ferryAccount: "pasazieru-pramji/konts",
    locales: ["lv-lv"],
    profile: "mans-profils"
  },
  {
    bookings: "uzsakymai",
    consent: "sutikimai-ir-bendravimas",
    ferryAccount: "keleiviniai-keltai/paskyra",
    locales: ["lt-lt"],
    profile: "mano-profilis"
  },
  {
    bookings: "bestillinger",
    consent: "samtykke-og-kommunikasjon",
    ferryAccount: "ferge/konto",
    locales: ["no-nb"],
    profile: "min-profil"
  },
  {
    bookings: "rezerwacje",
    consent: "zgody-i-komunikacja",
    ferryAccount: "promy-pasazerskie/konto",
    locales: ["pl-pl"],
    profile: "moj-profil"
  },
  {
    bookings: "bokningar",
    consent: "samtycke-integritet",
    ferryAccount: "passagerarfartyg/konto",
    locales: ["sv-se"],
    profile: "min-profil"
  }
];
export {
  badgeHref
};
